import type { z } from 'zod';

import { z as zod } from 'zod';

export const contactSchema = (t: (key: string, options?: Record<string, any>) => string) =>
  zod.object({
    firstName: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.name') }),

    lastname: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.lastname') }),

    email: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.email') })
      .email({ message: t('fields.invalid.email') }),

    phone: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.phone') })
      .regex(/^\+?[1-9]\d{7,14}$/, { message: t('fields.invalid.phone') }),

    message: zod
      .string()
      .trim()
      .min(1, { message: t('fields.required.message') }),
  });

export type ContactSchemaType = z.infer<ReturnType<typeof contactSchema>>;
